export default "__VITE_ASSET__Dcf80z$$__"